import React, { useEffect } from 'react'
import RegionDatePicker from '@/components/RegionDatePicker'
import EndDateFormItem from './EndDateFormItem'
import dayjs from 'dayjs'
import {  FormPro } from '@roo/roo'

import { useTranslation } from '@sailor/i18n-web'
import { EndTimeTypeEnum } from '../utils'
import { FormInstance } from '@roo/roo/FormPro'
import { RulePackageRes } from '../utils/types'
import { useFormContext } from '../context/formContext'

/** 生效时间startTime  结束时间endTime */
const TimeFormItems = (props: { form: FormInstance}) => {
  const { form } = props
  const { t } = useTranslation()
  const formStartTime = FormPro.useWatch('startTime', form)
  const yesterday = dayjs().subtract(1, 'day')
    .endOf('day')
  const disabledEndDay =  formStartTime ? dayjs(formStartTime).subtract(1, 'day')
    .endOf('day') : yesterday
  useEffect(() => { // 开始时间变化时,校验结束时间
    form.validateFields(['endTime'])
  }, [formStartTime])


  const { ruleEffectStatus: effectiveStatus } = useFormContext()


  return (
    <>
      <FormPro.Item
        label={t('e_pc_effect_time', '生效时间')}
        name="startTime"
        required
        tooltip={t('e_pc_select_effect_time', '请选择生效时间')}
        rules={[{ required: true }]}
      >
        <RegionDatePicker disabledDate={cur => cur.isBefore(yesterday)} disabled={effectiveStatus !== 'notStart'}/>
      </FormPro.Item>
      <FormPro.Item
        label={t('e_pc_end_time', '结束时间')}
        name="endTime"
        required
        tooltip={t('e_pc_select_end_time', '请选择结束时间')}
        rules={[
          { required: true },
          {
            validator: (_, value) => {
              if (value?.type === EndTimeTypeEnum.CUSTOM && formStartTime && dayjs(value.time).isBefore(formStartTime)) {
                return Promise.reject(t('e_pc_end_time_cannot_be_earlier_than_start_time', '结束时间不能早于生效时间'))
              }
              return Promise.resolve()
            },
          },
        ]}
      >
        <EndDateFormItem  disabledDate={cur => (cur.isBefore(disabledEndDay) || cur.isBefore(yesterday))} disabled={effectiveStatus === 'expired'}/>
      </FormPro.Item>
    </>
  )
}
export default TimeFormItems